import React from "react";
import { Button } from '@themesberg/react-bootstrap';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaEdit, FaEye, FaPlus, FaArrowLeft } from 'react-icons/fa';

function DirectionPathButton({ disabled = false, text, path, variant }) {
  const navigate = useNavigate();
  const version = useSelector((state) => state.uiVersion?.version || 'v2');

  // Modern V2 representation
  if (version === 'v2') {
    const lowerText = (text || '').toLowerCase().trim();

    if (lowerText === 'editar' || lowerText === 'modificar') {
      return (
        <button
          type="button"
          disabled={disabled}
          className="v2-action-btn v2-action-edit"
          title={text}
          aria-label={text}
          onClick={() => navigate(path)}
        >
          <FaEdit />
        </button>
      );
    }

    if (lowerText === 'detalle' || lowerText === 'ver') {
      return (
        <button
          type="button"
          disabled={disabled}
          className="v2-action-btn v2-action-edit"
          title={text}
          aria-label={text}
          onClick={() => navigate(path)}
        >
          <FaEye />
        </button>
      );
    }

    if (lowerText.startsWith('crear') || lowerText.startsWith('nuevo')) {
      return (
        <button
          type="button"
          disabled={disabled}
          className="v2-btn v2-btn-primary mb-3"
          onClick={() => navigate(path)}
        >
          <FaPlus /> {text}
        </button>
      );
    }

    if (lowerText === 'regresar') {
      return (
        <button
          type="button"
          disabled={disabled}
          className="v2-btn v2-btn-secondary"
          onClick={() => navigate(path)}
        >
          <FaArrowLeft className="me-1" /> {text}
        </button>
      );
    }

    return (
      <button
        type="button"
        disabled={disabled}
        className="v2-btn v2-btn-secondary"
        onClick={() => navigate(path)}
      >
        {text}
      </button>
    );
  }

  // Classic V1 representation
  return (
    <div>
      <Button disabled={disabled} variant={variant} size="sm" onClick={() => navigate(path)}>
        {text}
      </Button>
    </div>
  );
}

export default DirectionPathButton;
